"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadDevLogin = void 0;
const contactCenter_1 = require("../../contactCenter");
const fakeLogin_renderizers_1 = require("./fakeLogin.renderizers");
const loadDevLogin = async (config, DevelopmentLogin) => {
    if ((0, contactCenter_1.isContactCenter)()) {
        (0, fakeLogin_renderizers_1.initializeDevCCLogin)(config, DevelopmentLogin);
    }
    else {
        (0, fakeLogin_renderizers_1.initializeDevWebLogin)(config, DevelopmentLogin);
    }
};
exports.loadDevLogin = loadDevLogin;
//# sourceMappingURL=fakeLogin.loaders.js.map